import React from 'react';
import { Link } from 'react-router-dom';
import AdviceCard from '../components/insights/AdviceCard';
import CoachingInsightCard from '../components/insights/CoachingInsightCard';

// Insights tells you what to focus on (the coach), what your own data suggests
// you could try (suggestions), and lets you test one change properly
// (experiments). Progress/measurement lives on the You page — the single source
// for "where am I and where am I heading" — so it deliberately isn't duplicated
// here.
//
// Suggestions sit above the coach on purpose: the coach reasons from general
// health knowledge about your numbers, while a suggestion comes from a pattern
// confirmed in your own record over weeks. When both have something to say, the
// one built out of your own history is the one worth reading first.

const InsightsPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-10">
      <div className="space-y-6">
        {/* Experiments launcher — the n-of-1 "try one change" surface. */}
        <Link
          to="/experiments"
          className="block rounded-xl border border-surface-border dark:border-surface-dark-border
                     bg-surface-card dark:bg-surface-dark-card p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-base font-semibold text-gray-900 dark:text-white">
                Run an experiment
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-0.5">
                Change one thing for a couple of weeks and see honestly what moved.
              </p>
            </div>
            <span className="text-primary-600 dark:text-primary-400 text-xl shrink-0" aria-hidden>→</span>
          </div>
        </Link>

        {/* Suggestions drawn from patterns confirmed in your own data. Renders
            nothing at all until the engine has something it can stand behind. */}
        <AdviceCard />

        {/* AI Health Coach — the prioritized focus list. */}
        <CoachingInsightCard />
      </div>
    </div>
  );
};

export default InsightsPage;
